"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.intoCartItem = void 0;

var intoCartItem = function intoCartItem(item, index) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;

  return Object.assign({
    id: index + 1,
    ryersonSku: item.mm,
    quantity: item.qty,
    quantityUom: item.quom,
    pricingUom: item.puom,
    customerRefNumber: (item === null || item === void 0 ? void 0 : item.crn) || "",
    purchaseOrderNumber: (item === null || item === void 0 ? void 0 : item.po) || "",
    notes: (item === null || item === void 0 ? void 0 : item.note) || "",
    domesticRequired: (item === null || item === void 0 ? void 0 : item.domestic) || false,
    requestedDeliveryDate: (item === null || item === void 0 ? void 0 : item.rdd) || null
  }, item.process && {
    processing: {
      process: ((_a = item.process) === null || _a === void 0 ? void 0 : _a.proc) || "",
      finish: ((_b = item.process) === null || _b === void 0 ? void 0 : _b.fnsh) || "",
      shape: ((_c = item.process) === null || _c === void 0 ? void 0 : _c.shp) || "",
      length: ((_d = item.process) === null || _d === void 0 ? void 0 : _d.len) || null,
      width: ((_e = item.process) === null || _e === void 0 ? void 0 : _e.wid) || null,
      outsideDiameter: ((_f = item.process) === null || _f === void 0 ? void 0 : _f.outsdDia) || null,
      insideDiameter: ((_g = item.process) === null || _g === void 0 ? void 0 : _g.insdDia) || null,
      toleranceMin: ((_h = item.process) === null || _h === void 0 ? void 0 : _h.tolMin) || null,
      toleranceMax: ((_j = item.process) === null || _j === void 0 ? void 0 : _j.tolMax) || null,
      toleranceMinInsideDiameter: ((_k = item.process) === null || _k === void 0 ? void 0 : _k.tolMinInsdDia) || null,
      toleranceMaxInsideDiameter: ((_l = item.process) === null || _l === void 0 ? void 0 : _l.tolMaxInsdDia) || null
    }
  });
};

exports.intoCartItem = intoCartItem;